import { serializable, object, list, alias } from 'serializr';
import { CategoryItem, FinishedGoods } from './categoryItems.model';

export class Category4 {
  @serializable(list(object(CategoryItem)))
  ingredients?: CategoryItem[] = [];

  @serializable(list(object(CategoryItem)))
  packagings?: CategoryItem[] = [];

  @serializable(list(object(CategoryItem)))
  others?: CategoryItem[] = [];

  @serializable(alias('finished_goods', object(FinishedGoods)))
  finishedGoods?: FinishedGoods | null = null;
}
